import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { postApi } from '../../../Services/apiService';
import 'react-toastify/dist/ReactToastify.css';

function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [emailActive, setEmailActive] = useState(false);
    const [passwordActive, setPasswordActive] = useState(false);
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();
    const [loader, setLoader] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        const userDetails = JSON.parse(localStorage.getItem('userDetail'));
        if (userDetails) {
            if (userDetails.role === '1') {
                navigate('/user/dashboard');
            } else if (userDetails.role === '2') {
                navigate('/notary/dashboard');
            }
        }
    }, [navigate]);

    const validateForm = () => {
        let validationErrors = {};

        if (!email.trim()) {
            validationErrors.email = 'Email is required.';
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            validationErrors.email = 'Invalid email format.';
        }

        if (!password.trim()) {
            validationErrors.password = 'Password is required.';
        } else if (password.length < 6) {
            validationErrors.password = 'Password must be at least 6 characters.';
        }

        setErrors(validationErrors);
        return Object.keys(validationErrors).length === 0;
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        if (!validateForm()) return; // If validation fails, stop execution.

        setLoader(true);
        try {
            const insertData = { email, password };
            const response = await postApi('/admin/login', insertData);
            if (response?.status === 200) {
                localStorage.setItem("userDetail", JSON.stringify(response?.user_details));
                localStorage.setItem("token", JSON.stringify(response?.user_details?.token));
                
                if (response?.user_details?.role == 1) {
                    setLoader(false);
                    navigate('/admin/user-management');
                } else {
                    localStorage.clear();
                    navigate('/');
                }
            }
        } catch (error) {
            console.error('Login error:', error);
        }
        setLoader(false);
    };

    return (

        <div className='sign-up-main login'>
            <span className='login-shape'><img src={window.getPublicUrl("/assets/images/login-shape.svg") } alt="Main Logo" /></span>
            <span className='login-shape-right'><img src={window.getPublicUrl("/assets/images/login-shape-right.svg") } alt="Main Logo" /></span>
            <div className='sign-left'>
                <div className="login-container">
                <div className='login-logo'><img src={window.getPublicUrl("/assets/images/login-logo.svg") } alt="Main Logo" /></div>
                    <h2>Login</h2>
                    <h4>Enter your email and password to sign in.</h4>
                    <form onSubmit={handleLogin}>
                        {/* Email Field */}
                        <div className={`custom-floating-group ${emailActive ? 'active' : ''}`}>
                            <input
                                type="email"
                                placeholder=" "
                                value={email}
                                onChange={(e) => {
                                    setEmail(e.target.value);
                                    setErrors({ ...errors, email: '' }); // Clear error when user types
                                }}
                                onFocus={() => setEmailActive(true)}
                                onBlur={(e) => setEmailActive(!!e.target.value)}
                            />
                            <label>Email</label>
                        {errors.email && <div className="error">{errors.email}</div>}
                        </div>

                        {/* Password Field */}
                        <div className={`custom-floating-group ${passwordActive ? 'active' : ''}`}>
                            <input
                                type={showPassword ? 'text' : 'password'}
                                placeholder=" "
                                value={password}
                                onChange={(e) => {
                                    setPassword(e.target.value);
                                    setErrors({ ...errors, password: '' }); // Clear error when user types
                                }}
                                onFocus={() => setPasswordActive(true)}
                                onBlur={(e) => setPasswordActive(!!e.target.value)}
                            />
                            <label>Password</label>
                            <span className="eye-icon" onClick={() => setShowPassword(!showPassword)}>
                                <img src={showPassword ? window.getPublicUrl("/assets/images/Eye.svg") : window.getPublicUrl("/assets/images/Eye-closed.svg")} alt="Toggle Password" />
                            </span>
                        {errors.password && <div className="error">{errors.password}</div>}
                        </div>

                        {/* Sign In Button */}
                        <Button className='sign-in-btn' type="submit" disabled={loader}>
                            {loader && <div className="spinner-border" role="status"><span className="sr-only"></span></div>}
                            Sign in
                        </Button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Login;
